import { render, staticRenderFns } from "./CustomerYtdSalesNumberDisplayer.vue?vue&type=template&id=3758297a"
import script from "./CustomerYtdSalesNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./CustomerYtdSalesNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports